import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import LandlordDetails from "@/components/journey/HomeComponents/LandlordDetails";
import FlatmatesDetails from "@/components/journey/HomeComponents/FlatmatesDetails";
import LineRight from "@/assets/images/Line 961.png";
import Whatsapp from "@/assets/images/whatsapp.png";
import FAQ from "@/assets/icons/faq.png";
import BannerIcon from "@/assets/icons/banner-icon.svg";
import ReferEarnIcon from "@/assets/icons/refer-earn-icon.svg";
import LineLeft from "@/assets/images/Line 962.png";
import { ArrowUpRight, MoveRight, ArrowRight } from "lucide-react";
import { updateFunction } from "@/lib/helper";
import PrimaryButton from "@/components/common/buttons/PrimaryButton";
import Loader from "@/components/common/Loader";
import CustomDrawer from "@/components/common/drawer";
import GoBackButton from "@/components/common/buttons/GoBackButton";
import DynamicInputForm from "@/components/common/DynamicInputForm";
import BtnBgImg from "@/assets/images/button-bg-img.png";

const EnterRent = [
  {
    type: "text",
    label: "Enter Amount",
    name: "amount",
    required: true,
    pattern: "^[a-zA-Z]+(?:s+[a-zA-Z]+){1,2}$",
  },
];

function ZeroDepositBtn() {
  const navigate = useNavigate();

  return (
    <div
      className="flex flex-col items-center gap-4 border border-[#242424] bg-center p-4"
      style={{
        backgroundImage: `url(${BtnBgImg})`,
      }}
    >
      <span className="text-[#d0d0d0] text-sm font-medium">
        Need help with your landlord to enable ZERO Deposit process
      </span>
      <div className="flex w-full items-center justify-end">
        {/* Gradient Border Wrapper */}
        <div className="rounded-full p-[0.5px] bg-gradient-to-r from-[#ffffff] via-[#6d6d6d] to-[#6E6E6E]">
          {/* Actual Button */}
          <button
            className="flex items-center px-6 py-1 font-medium bg-black text-white rounded-full"
            onClick={() => navigate("/view-landlord")}
          >
            <span className="text-white text-2xs font-semibold">Proceed</span>
            <ArrowRight className="w-3" />
          </button>
        </div>
      </div>
    </div>
  );
}

export default function OnboardedUserContent({ userData }) {
  const navigate = useNavigate();
  const [error, setError] = useState();
  const [loading, setLoading] = useState();
  const [paymentDrawer, setPaymentDrawer] = useState();
  const [formData, setFormData] = useState({});

  useEffect(() => {
    if (formData?.amount && formData?.amount.length > 2) {
      setError();
    }
  }, [formData]);

  const payRent = async () => {
    try {
      setLoading(true);
      console.log(formData?.amount);

      if (!formData?.amount) {
        setError("Enter Rent");
        return;
      }

      const body = {
        amount: formData?.amount,
        purpose: "Rent payment",
        customer_details: {
          customerPhone: userData?.phone,
        },
      };

      const res = await updateFunction(body, "public/create-payment");
      // console.log(res.body);
      if (res.link_url) {
        window.location.href = res.link_url;
      } else {
        setError(res.message);
      }
    } catch (error) {
      console.log(error);
      setError("An error occurred");
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col w-full justify-between gap-2 bg-cover bg-center">
      {/* <div className="flex flex-row justify-center items-center">
        {" "}
        <span>
          <img src={LineLeft} />
        </span>
        <div className="text-center font-semibold text-xs whitespace-nowrap px-2">
          MOVE-IN PROCESS
        </div>{" "}
        <span>
          <img src={LineRight} />
        </span>
      </div> */}
      {/* <div className="uppercase w-full text-2xs flex gap-4 items-center justify-center">
      <div class="h-[2px] w-full bg-gradient-to-r from-blue-500/0 via-white/10 to-white"></div>
      <span className="min-w-max">Move-in Process</span>
      <div class="h-[2px] w-full bg-gradient-to-l from-blue-500/0 via-white/10 to-white"></div>
      </div> */}

      <div className="flex flex-col gap-2 p-2">
        {!["ONBOARDING_INIT", "ONBOARDING_DONE"].includes(userData.dealStage) && <ZeroDepositBtn />}
        {/* {userData.property?.landlordId && (
          <LandlordDetails landlordId={userData.property?.landlordId} />
        )} */}
        {userData.dealStage === "ONBOARDING_INIT" && (
          <button
            onClick={() =>
              navigate(
                userData?.acceptedRentSummary ? "/onboarding" : "/rent-summary"
              )
            }
            className="gap-2 bg-white text-xs text-black flex items-center py-2 justify-center font-medium"
          >
            Let's Start Onboarding
            <MoveRight />
          </button>
        )}
        {/* {userData.dealStage === "ONBOARDING_INIT" && (
          <button
            onClick={() => setPaymentDrawer(true)}
            className="gap-2 bg-black border text-xs text-white flex items-center py-2 justify-center font-medium"
          >
            Pay Rent
            <ArrowUpRight />
          </button>
        )} */}
        <CustomDrawer isOpen={paymentDrawer}>
          <GoBackButton customBackSubmit={() => setPaymentDrawer(false)} />
          <div className="w-full text-left  ">
            <div className="heading mb-6 mt-12 ">Enter Your Rent</div>

            {/* <div className="text-xl text-[#999]">Phone: {userData?.phone}</div> */}
            {/* <div className="text-xl text-[#999]">Rent: {userData?.property?.rent}</div> */}
            <DynamicInputForm
              formConfig={EnterRent}
              formData={formData}
              setFormData={setFormData}
              setError={setError}
            />
          </div>
          <div className="flex-grow overflow-auto mt-5">
            {error && (
              <div className="w-full p-2 px-4 bg-red-400/10 text-red-400 rounded-lg">
                {error}
              </div>
            )}
          </div>

          <div className="pt-6">
            {loading ? (
              <Loader />
            ) : (
              <PrimaryButton text="Pay" handleClick={() => payRent()} />
            )}
          </div>
        </CustomDrawer>

        {/* <FlatmatesDetails mydata={userData}/> */}
      </div>
      {/* <div className="px-10">
        <PrimaryButton
          handleClick={() => navigate("/vishal")}
          text={"Start Onboarding"}
        />{" "}
      </div> */}

      {/* <div className="flex flex-row justify-evenly gap-2">
        <button className="flex flex-col gap-2 text-center justify-center items-center -mx-2">
          <div className="bg-black-light h-10 w-10 rounded-full flex justify-center items-center p-2 flex-col">
            <img src={BannerIcon} className="rounded-full scale-150" />
          </div>
          <p className="text-2xs text-center">View Benefits</p>
        </button>
        <button className="flex flex-col gap-2 text-center justify-center items-center -mx-2">
          <div className="bg-black-light h-10 w-10 rounded-full flex justify-center items-center p-2 flex-col">
            <img src={ReferEarnIcon} className="rounded-full scale-150" />
          </div>
          <p className="text-2xs text-center">Refer & Earn</p>
        </button>
        <button
          onClick={() => navigate("/faq")}
          className="flex flex-col gap-2"
        >
          <div className="bg-black-light h-10 w-10 rounded-full flex justify-center items-center p-2 flex-col">
            <img src={FAQ} />
          </div>
          <p className="text-2xs">FAQs</p>
        </button>
        <button className="flex flex-col gap-2 text-center justify-center items-center ">
          <div className="bg-black-light h-10 w-10 rounded-full flex justify-center items-center p-2 flex-col">
            <img src={Whatsapp} />
          </div>
          <p className="text-2xs text-center">Call Us</p>
        </button>
      </div> */}
    </div>
  );
}
